<ng-container *transloco="let t; prefix: 'reports'">
  <div class="flex flex-col items-center h-full w-full z-50 pt-2 pb-2 md:px-2">
    <div
      class="flex flex-col justify-center items-center max-w-sm mb-2 mt-10 p-4 bg-white dark:bg-base-200 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800 rounded-box"
    >
      <span
        class="flex size-20 justify-center items-center gap-1 rounded-full bg-gradient-to-b from-primary to-secondary text-white my-4"
      >
        <i class="fa-solid fa-file-chart-column text-4xl"></i>
      </span>
      <h4
        class="text-xs uppercase text-center text-white px-2 py-1 rounded-box mb-2 bg-gradient-to-r from-primary to-secondary"
      >
        {{ t("coming_soon") }}
      </h4>
      <h2 class="text-2xl font-semibold text-center w-full mb-2">
        {{ t("title") }}
      </h2>
      <h2 class="text-lg font-light text-center w-full mb-2">
        {{ t("subtitle") }}
      </h2>
    </div>
  </div>
</ng-container>
